import React from 'react'

import cn from '../../../../commons/src/libs/class-names'

export interface Props {
  classNames?: string[]
  values: Array<{left: string | number; right: string | number}>
  divider?: string
}

const StaggeredValues = ({classNames, values, divider = '≥'}: Props) => (
  <div className={cn('StaggeredValues', {}, classNames)}>
    {values &&
      values.map(({left, right}, index) => (
        <React.Fragment key={index}>
          <span className="StaggeredValues__price">{left}</span>
          <span className="StaggeredValues__divider">{divider}</span>
          <span className="StaggeredValues__threshold">{right}</span>
        </React.Fragment>
      ))}
  </div>
)

export default StaggeredValues
